// 运行时配置
// 全局初始化数据配置，用于 Layout 用户信息和权限初始化
// 更多信息见文档：https://umijs.org/docs/api/runtime-config#getinitialstate
import { APP_THEME } from '@/constants/theme';
import { videoConfigHandler } from '@/store/videoConfig';
import { getHeaderAuthorization, getUserToken } from '@/utils/loginHandler';
import type { RequestConfig } from '@umijs/max';
import { history } from '@umijs/max';
import { ConfigProvider } from 'antd';
import React from 'react';
import { getUserInfo } from './services/api/api0';

ConfigProvider.config({
  holderRender: (children) => (
    <ConfigProvider theme={APP_THEME}>{children}</ConfigProvider>
  ),
});

export function rootContainer(container: React.ReactNode) {
  return React.createElement(
    ConfigProvider,
    {
      theme: APP_THEME,
    },
    container,
  );
}

export async function getInitialState(): Promise<{
  currentUser?: API.Users;
  videoConfig?: API.TaskParamResp;
}> {
  const videoConfig = await videoConfigHandler.getVideoConfig();
  const userInfo = getUserToken();

  if (!userInfo) {
    history.push('/login');
    return {
      videoConfig,
    };
  }
  try {
    const response = await getUserInfo({ userId: userInfo.id! });
    return {
      currentUser: response.data,
      videoConfig,
    };
  } catch (error) {
    history.push('/login');
    return {
      videoConfig,
    };
  }
}

// 请求配置
export const request: RequestConfig = {
  // 请求拦截器
  requestInterceptors: [
    (config: any) => {
      // 为每个请求添加通用header
      const authorization = getHeaderAuthorization();
      if (authorization) {
        config.headers = {
          ...config.headers,
          ...authorization,
        };
      }

      return config;
    },
  ],

  // 响应拦截器（可选）
  responseInterceptors: [
    (response: any) => {
      // 可以在这里处理响应数据
      return response;
    },
  ],
};
